import styled from 'styled-components';
import { colors } from '@omilia/theme';
import { H3, Text } from '@omilia/typography';
import { rgba } from 'polished';

import lineImg from 'styles/images/line.png';

const COLOR_GREY = rgba(colors.COLOR_GREY_1000, 0.16);

export const SLayout = styled.div`
  align-items: center;
  background-color: ${colors.COLOR_OMILIA_BLUE_100};
  display: flex;
  flex-direction: column;
  height: 1px;
  justify-content: flex-start;
  min-height: 100vh;
  overflow: auto;
  padding-top: 124px;
`;

export const SH3 = styled(H3)`
  color: ${colors.COLOR_GREY_800};
  margin: 64px 0;
  position: relative;
  text-align: center;

  &:before {
    top: -10px;
  }

  &:after {
    bottom: -10px;
  }

  &:before,
  &:after {
    background: url(${lineImg}) no-repeat center;
    content: '';
    height: 1px;
    left: 0;
    opacity: 60%;
    position: absolute;
    right: 0;
    width: 100%;
  }
`;

export const SInner = styled.section`
  flex: 1;
  max-width: 440px;
  width: 100%;
`;

export const SForm = styled.form`
  background-color: ${colors.COLOR_WHITE};
  border: 1px solid ${colors.COLOR_GREY_300};
  border-radius: 6px;
  box-shadow: 5px 10px 20px 0 ${COLOR_GREY};
  padding: 32px 50px;

  /* each child textfield wrapper fix */
  & > div {
    margin: 1rem 0 0;
    min-height: 0;
    padding-bottom: 20px;
  }
`;

export const SFooter = styled.section`
  background: ${colors.COLOR_WHITE};
  border-radius: 50% / 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  height: 100px;
  text-align: center;
  width: 100%;
`;

export const SFooterText = styled(Text)`
  color: ${colors.COLOR_GREY_800};
  margin: 48px 0 32px;
  text-align: center;
`;

export const SExtraInfo = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 21px;
`;

export const SExtraInfoText = styled(Text)`
  color: ${colors.COLOR_BLUE_600};
  text-align: center;
  margin-left: 7px;
`;
